var _rect, _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecentSupportersPlaceholder = function SvgRecentSupportersPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 759,
    height: 200,
    viewBox: "0 0 759 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 759,
    height: 200,
    rx: 8,
    fill: "url(#recent_supporters_placeholder_svg__paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 759,
    height: 200
  }, /*#__PURE__*/React.createElement("rect", {
    width: 759,
    height: 200,
    rx: 8,
    fill: "#C8E8E1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.682 148.333a29.522 29.522 0 011.854-11.397 29.043 29.043 0 016.068-9.749 28.34 28.34 0 019.314-6.549 27.812 27.812 0 0111.079-2.305c3.807 0 7.575.784 11.079 2.305a28.341 28.341 0 019.315 6.549 29.04 29.04 0 016.067 9.749 29.514 29.514 0 011.854 11.397h-56.63zM172.013 148.333a18.693 18.693 0 011.309-7.598 19.206 19.206 0 014.283-6.499 20.019 20.019 0 016.575-4.366 20.626 20.626 0 017.82-1.537c2.687 0 5.347.523 7.82 1.537a20.019 20.019 0 016.575 4.366 19.206 19.206 0 014.283 6.499 18.693 18.693 0 011.309 7.598h-39.974z",
    fill: "#61B29F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.5,
    cy: 283,
    rx: 259.5,
    ry: 142,
    fill: "#C8E8E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 60,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 64,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -7,
    cy: 56,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 52,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23 59h65v13h-65z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 74,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 74,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 78,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 70,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 66,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 73h65v13h-65z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.333 81.667h93.334V135h-93.334V81.667z",
    fill: "#93CBBE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.333,
    y: 35,
    width: 53.333,
    height: 26.667,
    rx: 3.333,
    fill: "#93CBBE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M132 41.667h40V55h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.667 61.667h6.666V65h-6.666v-3.333zM168.667 61.667h6.667V65h-6.667v-3.333z",
    fill: "#93CBBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 81.667h100V75H102v6.667z",
    fill: "#7FB7AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.666 75h106.667V65H98.667v10z",
    fill: "#93CBBE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7FB7AA",
    d: "M102 148.333h100V135H102z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDEDE6",
    d: "M112 90h48.333v38.333H112z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.667 90H157l-13.333 38.333h-3.334L153.667 90zM150.334 90H152l-13.333 38.333H137L150.334 90z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDEDE6",
    d: "M167 90h25v45h-25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.378 138.049a16.74 16.74 0 01-16.417-20.004 16.74 16.74 0 0113.151-13.152 16.747 16.747 0 0117.184 7.118 16.741 16.741 0 012.821 9.299 16.761 16.761 0 01-16.739 16.739z",
    fill: "#61B29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.378 121.318h-16.76v6.813a12.158 12.158 0 01-5.264 9.918 9.119 9.119 0 1014.382 7.459 8.814 8.814 0 00-.155-1.586h7.797v-22.604z",
    fill: "#61B29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.356 133.652c6.812 0 12.334-5.522 12.334-12.334 0-6.812-5.522-12.334-12.334-12.334-6.812 0-12.334 5.522-12.334 12.334 0 6.812 5.522 12.334 12.334 12.334z",
    fill: "#B8D8D1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 84.888,
    y: 145.123,
    width: 30.943,
    height: 15.471,
    rx: 2,
    fill: "#59A593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.198 150.504c0-5.074 0-7.61 1.576-9.187 1.576-1.576 4.113-1.576 9.187-1.576h14.798c5.074 0 7.611 0 9.187 1.576 1.576 1.577 1.576 4.113 1.576 9.187v.709c0 1.885 0 2.828-.586 3.414-.586.586-1.528.586-3.414.586H86.198c-1.886 0-2.828 0-3.414-.586-.586-.586-.586-1.529-.586-3.414v-.709z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.356 131.596v8.905",
    stroke: "#B8D8D1",
    strokeWidth: 5.381,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.973 124.673a5.62 5.62 0 01-5.613 5.819 5.617 5.617 0 01-5.612-5.819h11.225z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.315 113.492c-.058 0-9.389-6.703-9.389-6.703l-2.548 1.71-2.562-1.71s-9.331 6.732-9.397 6.703c-.066-.03-1.402 7.826-1.402 7.826h1.762a12.298 12.298 0 009.654-4.669 2.485 2.485 0 013.031-.694c.338.163.634.4.867.694a12.266 12.266 0 009.647 4.669h1.769s-1.365-7.856-1.432-7.826z",
    fill: "#61B29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.208 142.922c.642-1.301 2.497-1.301 3.139 0 .255.516.748.874 1.318.957 1.436.209 2.009 1.973.97 2.986a1.749 1.749 0 00-.503 1.549c.245 1.43-1.256 2.521-2.54 1.845a1.75 1.75 0 00-1.629 0c-1.284.676-2.785-.415-2.54-1.845a1.749 1.749 0 00-.503-1.549c-1.039-1.013-.466-2.777.97-2.986a1.752 1.752 0 001.318-.957z",
    fill: "#B8D8D1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.777,
    cy: 146.468,
    r: 2.018,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "recent_supporters_placeholder_svg__paint0_linear",
    x1: 379.5,
    y1: 0,
    x2: 379.5,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8E8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8E8E1",
    stopOpacity: 0.4
  })))));
};
export { SvgRecentSupportersPlaceholder as ReactComponent };
export default "data:image/svg+xml;base64,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";